var hasProp = window.hasProp;
var extend = window.extend;
var bind = window.bind;
var bind = function (fn, me) {
    return function () {
      return fn.apply(me, arguments);
    };
  },
  extend = function (child, parent) {
    for (var key in parent) {
      if (hasProp.call(parent, key)) child[key] = parent[key];
    }
    function ctor() {
      this.constructor = child;
    }
    ctor.prototype = parent.prototype;
    child.prototype = new ctor();
    child.__super__ = parent.prototype;
    return child;
  },
  hasProp = {}.hasOwnProperty;
window.Search.ResearchInterestSearch = function (superClass) {
  extend(ResearchInterestSearch, superClass);
  function ResearchInterestSearch() {
    this.formatResult = bind(this.formatResult, this);
    return ResearchInterestSearch.__super__.constructor.apply(this, arguments);
  }
  ResearchInterestSearch.prototype.resultTemplate = 'search/templates/research_interest_result';
  ResearchInterestSearch.prototype.initialize = function (options) {
    this.allowCreation = options.allowCreation;
    this.collection = options.collection;
    this.maximumSelectionSize = options.maximumSelectionSize || 1000;
    _.defaults(options, {
      placeholder: 'Find a research interest...',
      multiple: true,
      ajax: {
        url: '/tags/search',
        data: function (_this) {
          return function (term, page) {
            return {
              q: term,
              exclude_tags: JSON.stringify(_this.collection.pluck('id'))
            };
          };
        }(this),
        results: function (_this) {
          return function (data, page) {
            return {
              results: _this._parseSearchResults(data.results)
            };
          };
        }(this)
      }
    });
    return ResearchInterestSearch.__super__.initialize.apply(this, arguments);
  };
  ResearchInterestSearch.prototype.formatSelection = function (ri, container, escapeMarkup) {
    return escapeMarkup(ri.get('name'));
  };
  ResearchInterestSearch.prototype.formatResult = function (ri, container, query, escapeMarkup) {
    return JST[this.resultTemplate]({
      ri: ri.toJSON()
    });
  };
  ResearchInterestSearch.prototype.formatResultCssClass = function () {
    return 'bordered-search-result bootstrap';
  };
  ResearchInterestSearch.prototype._parseSearchResults = function (ris) {
    return _(ris).map(function (ri) {
      return new Backbone.Model({
        id: ri.id,
        name: ri.display_name,
        followers: ri.weight
      });
    });
  };
  return ResearchInterestSearch;
}(window.Search.Base);
window.bind = bind;
window.extend = extend;
window.hasProp = hasProp;